/* eslint-disable */

import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { useLoad } from "../../hooks/request";
import { useQueryParams } from "../../hooks/queryString";
import Button from "../../components/common/Button";
import { useModal } from "../../hooks/modal";
import Layout from "../../components/Layout";
import { PAYMENT_LIST } from "../../urls";
import PaymentCreate from "./PaymentCreate";
import PaymentItem from "./PaymentItem";
import BuildingTabs from "../../components/BuildingTabs";
import Table from "../../components/common/Table";


export default function Payment() {
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})

    const searchParam = useQueryParams()
    const payment = useLoad({
        url: PAYMENT_LIST,
        params: { page, ...params, ...searchParam }
    }, [searchParam, page, params])

    const productList = payment.response ? payment.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(
        <PaymentCreate
            expenseReport={payment}
            onCancel={() => setShowCreateModal()}/>, styles.modal)

    return (
        <Layout showCreateModal={showCreateModal}>
            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h2 className="title is-size-4">Тўловлар</h2>
                <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal}/>
            </div>
            <BuildingTabs/>

            <div>
                <div className="mt-4 mb-4">
                    <Table
                        loading={payment.loading}
                        items={productList}
                        columns={{
                            index: '№',
                            datae: 'Шартнома',
                            date: 'Тўлов вақти',
                            amount: 'Тўлов суммаси',
                            Ramount: 'Қолган сумма',
                            buttons: ''
                        }}
                        totalCount={payment.response ? payment.response.count : 0}
                        activePage={page}
                        onPageChange={setPage}
                        renderItem={(item, index) =>
                            <PaymentItem
                                payment={payment}
                                index={index}
                                key={item.id}
                                item={item}/>}
                    />

                </div>
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 },
    checkmark: { marginRight: '3px' },
})
